.subcategories__listing__main {
  background-color: #fafafa;
}

.listing-page-recommendations {
  display: block;
  padding: 0 16px;
}